/**
 * Resize and compress an image file for use as team logo (base64).
 * Keeps league JSON size reasonable (target ~50–80KB).
 * @param {File} file - Image file
 * @param {number} maxSize - Max width/height in pixels (default 200)
 * @param {number} quality - JPEG quality 0–1 (default 0.85)
 * @returns {Promise<string>} - Data URL (e.g. data:image/jpeg;base64,...)
 */
export function resizeImageToDataUrl(file, maxSize = 200, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const w = img.naturalWidth;
      const h = img.naturalHeight;
      let width = w;
      let height = h;
      if (w > maxSize || h > maxSize) {
        if (w > h) {
          width = maxSize;
          height = Math.round((h * maxSize) / w);
        } else {
          height = maxSize;
          width = Math.round((w * maxSize) / h);
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      try {
        const dataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(dataUrl);
      } catch (e) {
        reject(e);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image'));
    };
    img.src = url;
  });
}
